import { ActionStatus } from '@/core/types/enums/action-status.enum'
import { zodResolver } from '@hookform/resolvers/zod'
import { useTransition } from 'react'
import { useForm } from 'react-hook-form'
import { addRateSchema } from '../../dtos/add-rate.model'
import { rateProduct } from '../../providers/server'

export function useAddReview({
  onSuccess,
  productSlug,
  productId,
}: {
  productSlug: string
  productId: number
  onSuccess: () => void
}) {
  const form = useForm({
    resolver: zodResolver(addRateSchema),
    defaultValues: {
      comment: '',
      rate: 5,
    },
  })

  const [isPending, startTransition] = useTransition()

  const handleSubmit = form.handleSubmit(data => {
    startTransition(async () => {
      const { error, status } = await rateProduct(productId, productSlug, data)
      if (status === ActionStatus.SUCCESS) onSuccess()

      if (error) {
        form.setError('comment', { message: error })
      }
    })
  })

  return {
    form,
    isPending,
    handleSubmit,
  }
}
